// Admin session token. Unlike the storefront's in-memory token, the admin panel
// persists its Bearer token in localStorage so a page reload keeps the admin
// signed in. This is intentionally separate from the storefront auth layer.

const STORAGE_KEY = 'ayat_admin_token';

export const adminToken = {
  get() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  },
  set(token) {
    try {
      localStorage.setItem(STORAGE_KEY, token);
    } catch {
      /* storage unavailable — session stays in memory only */
    }
  },
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  },
};
